/**
 * FissalGreeter.jsx — first-visit center prompt (#304).
 *
 * Shown once on the user's first visit (anon or logged-in). Dismissing
 * sets `redfur:onboarded.v1` so the prompt never re-appears without an
 * explicit user action (clearing localStorage). Also marks the hint
 * intro (#142) as onboarded to avoid two stacked modals on first paint.
 *
 * Microcopy is in Fissal's voice (Jone/Jode persona). Voice budget per
 * fissal-voice-curator: one in-voice sentence + utilitarian dismiss.
 */
import { Show, createSignal, onMount } from 'solid-js';
import { Portal } from 'solid-js/web';
import onboarding from '../lib/onboardingStore.js';
import { hints } from '../lib/hintsStore.js';
import { EMOJI } from '../lib/emoji.js';
import './FissalGreeter.css';

export default function FissalGreeter() {
  const [open, setOpen] = createSignal(false);

  onMount(() => {
    if (onboarding.isFirstVisit()) {
      // Brief delay so the desktop paints first; matches FissalOnboarding.
      setTimeout(() => setOpen(true), 450);
    }
  });

  function dismiss() {
    onboarding.markComplete();
    // Suppress the hint-intensity intro on the same visit so first-time
    // users only ever see one welcome modal.
    hints.markOnboarded();
    setOpen(false);
  }

  return (
    <Show when={open()}>
      <Portal>
        <div
          class="v2-fissal-greet__backdrop"
          role="dialog"
          aria-modal="true"
          aria-labelledby="v2-fgreet-title"
        >
          <div class="v2-fissal-greet">
            <span class="v2-fissal-greet__face" aria-hidden="true">{EMOJI.ai}</span>
            <div id="v2-fgreet-title" class="v2-fissal-greet__title">
              Fissal welcomes you, traveller.
            </div>
            <div class="v2-fissal-greet__msg">
              This one has laid out the <em>Leaderboard</em>, <em>Live Feed</em>, and
              <em> Price Check</em> on your desk. Tap any gear ⚙ when you need Fissal's
              calculations — the twin moons illuminate all trade.
            </div>
            <button
              type="button"
              class="v2-fissal-greet__close"
              onClick={dismiss}
              autofocus
            >
              Open the ledgers
            </button>
          </div>
        </div>
      </Portal>
    </Show>
  );
}
